const browser = {
    versions() {
        const u = navigator.userAgent
        return { //移动终端浏览器版本信息
            trident: u.indexOf('Trident') > -1, //IE内核
            presto: u.indexOf('Presto') > -1, //opera内核
            webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
            gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') === -1, //火狐内核
            mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
            ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
            android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或uc浏览器
            iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
            iPad: u.indexOf('iPad') > -1, //是否iPad
            webApp: u.indexOf('Safari') === -1, //是否web应该程序，没有头部与底部
            wechat: u.toLowerCase().indexOf('micromessenger') > -1, //判断是不是微信环境
            smmapp: u.toLowerCase().indexOf('smmapp') > -1, //判断是不是有色app线上
            smmapptest: u.toLocaleLowerCase().indexOf('testplatform') > -1,//判断是不是有色app测试环境
            mac: u.indexOf('Mac') > -1, // 是否为mac
            windows: u.indexOf('Windows') > -1 // 是否为windows
        }
    }
}

export function getEnv(): Env {
    if (browser.versions().smmapp || browser.versions().smmapptest) {
        return Env.App
    }
    if (browser.versions().mobile) {
        return Env.Phone
    }
    return Env.Web
}

// 是否是微信环境
export function isWeChat(): boolean {
    return browser.versions().wechat
}

// 获取是否是app测试环境
export function isAppTest(): boolean {
    return browser.versions().smmapptest
}

// 获取是否是app环境
export function isApp(): boolean {
    return browser.versions().smmapp || browser.versions().smmapptest
}

// 获取是否是android测试环境
export function isAndroid(): boolean {
    return browser.versions().android
}

export enum Env {
    Phone,
    App,
    Web
}

export let GlobalEnv = getEnv()

export function GetClientType(): number {
    if (browser.versions().wechat) {
        return 4
    }
    if (browser.versions().mobile) {
        return 7
    }
    if (browser.versions().ios) {
        // HybirdApp
        return 5
    }
    if (browser.versions().android) {
        // HybirdApp
        return 5
    }
    if (browser.versions().mac || browser.versions().windows) {
        return 6
    }
    return 0
}

export const isPc = (userAgentInfo: string) => {
    if (userAgentInfo) {
        const agents = [
            'Android',
            'iPhone',
            'SymbianOS',
            'Windows Phone',
            'iPod'
        ]
        for (const v of agents) {
            if (userAgentInfo.indexOf(v) > 0) {
                return false
            }
        }
        return true
    } else {
        return false
    }
}



// WEBPACK FOOTER //
// ./src/utils/env.ts